import associeradObjektVy from '../../../_Common/Components/BusinessCollectionComponents/associeradObjektVy';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import { AktivitetVy } from '../Aktivitet/AktivitetVy';

export const bokningAktivitet = associeradObjektVy(
  'BokAkt',
  collectionCompToObjektVy(AktivitetVy, 'aktivitet'),
  undefined,
  undefined,
  'bokningAktivitet',
  'TEDBOAktivitet'
);
